import { render } from "./eventRegistration.vue?vue&type=template&id=3dfa879e&scoped=true"
import script from "./eventRegistration.vue?vue&type=script&lang=js"
export * from "./eventRegistration.vue?vue&type=script&lang=js"

import "./eventRegistration.vue?vue&type=style&index=0&id=3dfa879e&lang=scss&scoped=true"
import "./eventRegistration.vue?vue&type=style&index=1&id=3dfa879e&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfa879e"]])

export default __exports__